import React from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Chip, Popover, MenuItem, Subheader, Divider, Avatar, Menu} from 'material-ui';
import AddIcon from 'material-ui/svg-icons/content/add-circle';
import utils from "../../utils/utils";
import _ from 'lodash';
import './StateChipSelect.css';

const PopoverType = {
    StateIncluded: 'stateIncluded',
    StateExcluded: 'stateExcluded',
    FlowAssigned: 'flowAssigned',
    FlowUnassigned: 'flowUnassigned'
};

export default class StateChipSelect extends React.Component {

    static propTypes = {
        project: PropTypes.PropTypes.shape({
            id: PropTypes.string,
            flows: PropTypes.array,
            states: PropTypes.array
        }).isRequired,
        excludeAllStates: PropTypes.bool.isRequired,
        stateIdsIncluded: PropTypes.array.isRequired,
        stateIdsExcluded: PropTypes.array.isRequired,
        flowIdsAssigned: PropTypes.array.isRequired,
        flowIdsUnassigned: PropTypes.array.isRequired,
        onExcludeAllStatesChange: PropTypes.func.isRequired,
        onIncludedStateIdRemove: PropTypes.func.isRequired,
        onExcludedStateIdRemove: PropTypes.func.isRequired,
        onIncludedStateIdAdd: PropTypes.func.isRequired,
        onExcludedStateIdAdd: PropTypes.func.isRequired,
        onAssignedFlowIdRemove: PropTypes.func.isRequired,
        onUnassignedFlowIdRemove: PropTypes.func.isRequired,
        onAssignedFlowIdAdd: PropTypes.func.isRequired,
        onUnassignedFlowIdAdd: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.state = Object.assign({
            popoverMenuOpen: false,
            popoverType: null,
            anchorEl: null
        });
    }

    onExcludeAllStatesChange = (event, isInputChecked) => {
        this.props.onExcludeAllStatesChange(isInputChecked);
    };

    onIncludedStateIdRemove = (event) => {
        let stateId = utils.getValueAtPathOfClosestParent(event.currentTarget, 'dataset.stateId');
        this.props.onIncludedStateIdRemove(stateId);
    };

    onExcludedStateIdRemove = (event) => {
        let stateId = utils.getValueAtPathOfClosestParent(event.currentTarget, 'dataset.stateId');
        this.props.onExcludedStateIdRemove(stateId);
    };

    onAssignedFlowIdRemove = (event) => {
        let flowId = utils.getValueAtPathOfClosestParent(event.currentTarget, 'dataset.flowId');
        this.props.onAssignedFlowIdRemove(flowId);
    };

    onUnassignedFlowIdRemove = (event) => {
        let flowId = utils.getValueAtPathOfClosestParent(event.currentTarget, 'dataset.flowId');
        this.props.onUnassignedFlowIdRemove(flowId);
    };

    onAddChipClick = (event) => {
        // This prevents ghost click.
        event.preventDefault();

        let popoverType = utils.getValueAtPathOfClosestParent(event.currentTarget, 'dataset.popoverType');

        this.setState({
            popoverMenuOpen: true,
            popoverType: popoverType,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            popoverMenuOpen: false
        });
    };

    onMenuChange = (event, value) => {
        switch (this.state.popoverType) {
            case PopoverType.StateIncluded:
                this.props.onIncludedStateIdAdd(value.id);
                break;
            case PopoverType.StateExcluded:
                this.props.onExcludedStateIdAdd(value.id);
                break;
            case PopoverType.FlowAssigned:
                this.props.onAssignedFlowIdAdd(value.id);
                break;
            case PopoverType.FlowUnassigned:
                this.props.onUnassignedFlowIdAdd(value.id);
                break;
            default:
                break;
        }
        this.handleRequestClose();
    };

    renderIncludedStates() {
        let result = [];

        if (!this.props.excludeAllStates) {
            let statesMapById = _.keyBy(this.props.project.states, 'id');
            let includedStates = this.props.stateIdsIncluded.map(stateId => statesMapById[stateId]);
            let includedStatesByFlowIdMap = _.groupBy(includedStates, 'flowId');

            _.forEach(includedStatesByFlowIdMap, (flowStates, flowId) => {
                if (result.length) {
                    result.push(<div key={`and-${flowId}`} className="itemFilterChipRowItem chipRowText logicalOperatorText">and</div>);
                }
                if (flowStates.length > 1) {
                    result.push(<div key={`ob-${flowId}`} className="itemFilterChipRowItem chipRowText">(</div>);
                }
                flowStates.forEach((state, idx) => {
                    if (idx > 0) {
                        result.push(<div key={`or-${flowId}-${idx}`} className="itemFilterChipRowItem chipRowText logicalOperatorText">or</div>);
                    }
                    result.push(
                        <Chip className="itemFilterChipRowItem itemFilterChip" key={state.id} data-state-id={state.id} onRequestDelete={this.onIncludedStateIdRemove}>
                            {state.name}
                        </Chip>
                    );
                });
                if (flowStates.length > 1) {
                    result.push(<div key={`cb-${flowId}`} className="itemFilterChipRowItem chipRowText">)</div>);
                }
            });
        }

        result.push(this.renderStateAddChip(PopoverType.StateIncluded));

        return result;
    }

    renderExcludedStates() {
        let result = [];

        if (!this.props.excludeAllStates) {
            let statesMapById = _.keyBy(this.props.project.states, 'id');
            let excludedStates = this.props.stateIdsExcluded.map(stateId => statesMapById[stateId]);

            excludedStates.forEach((state, idx) => {
                if (idx > 0) {
                    result.push(<div key={`and-${idx}`} className="itemFilterChipRowItem chipRowText logicalOperatorText">and</div>);
                }
                result.push(
                    <Chip className="itemFilterChipRowItem itemFilterChip" key={state.id} data-state-id={state.id} onRequestDelete={this.onExcludedStateIdRemove}>
                        {state.name}
                    </Chip>
                );
            });
        }

        result.push(this.renderStateAddChip(PopoverType.StateExcluded));

        return result;
    }

    renderStateAddChip(popoverType) {
        let className = 'itemFilterChipRowItem addChip';
        let onTouchTap;
        if (this.props.excludeAllStates) {
            className += ' disabled'
        } else {
            onTouchTap = this.onAddChipClick;
        }
        return (
            <Chip key="add" className={className} onTouchTap={onTouchTap} data-popover-type={popoverType}>
                <Avatar icon={<AddIcon />} backgroundColor="transparent" color="white" />
                Add State
            </Chip>
        );
    }

    popoverMenuStateItems() {
        let stateIdsIncluded = this.props.stateIdsIncluded;
        let stateIdsExcluded = this.props.stateIdsExcluded;
        let menuItems = [];
        let flowStatesMap = {};
        let subHeaderStyle = {lineHeight: '32px'};
        let stateIds;
        let oppositeStateIds;

        if (this.state.popoverType === PopoverType.StateIncluded) {
            stateIds = stateIdsIncluded;
            oppositeStateIds = stateIdsExcluded;
        } else {
            stateIds = stateIdsExcluded;
            oppositeStateIds = stateIdsIncluded;
        }

        this.props.project.flows.forEach(flow => {
            flowStatesMap[flow.id] = [];
        });

        this.props.project.states.forEach(state => {
            if (state.type === "normal") {
                flowStatesMap[state.flowId].push(state);
            }
        });

        this.props.project.flows.forEach((flow, index) => {
            if (index !== 0) {
                menuItems.push(<Divider key={"divider" + index}/>);
            }

            menuItems.push(<Subheader key={flow.id} style={subHeaderStyle}>{flow.name}</Subheader>);

            let flowDisabled = flowStatesMap[flow.id].some(state => oppositeStateIds.includes(state.id));
            flowStatesMap[flow.id].forEach(state => {
                let stateDisabled = flowDisabled || stateIds.includes(state.id);
                menuItems.push(<MenuItem key={state.id} value={state} primaryText={state.name} disabled={stateDisabled}/>);
            });
        });

        return menuItems;
    }

    renderAssignedFlows() {
        let result = [];

        let flowsMapById = _.keyBy(this.props.project.flows, 'id');
        let assignedFlows = this.props.flowIdsAssigned.map(flowId => flowsMapById[flowId]);

        assignedFlows.forEach(flow => {
            result.push(
                <Chip className="itemFilterChipRowItem itemFilterChip" key={flow.id} data-flow-id={flow.id} onRequestDelete={this.onAssignedFlowIdRemove}>
                    {flow.name}
                </Chip>
            );
        });

        result.push(this.renderFlowAddChip(PopoverType.FlowAssigned));

        return result;
    }

    renderUnassignedFlows() {
        let result = [];

        let flowsMapById = _.keyBy(this.props.project.flows, 'id');
        let unassignedFlows = this.props.flowIdsUnassigned.map(flowId => flowsMapById[flowId]);

        unassignedFlows.forEach(flow => {
            result.push(
                <Chip className="itemFilterChipRowItem itemFilterChip" key={flow.id} data-flow-id={flow.id} onRequestDelete={this.onUnassignedFlowIdRemove}>
                    {flow.name}
                </Chip>
            );
        });

        result.push(this.renderFlowAddChip(PopoverType.FlowUnassigned));

        return result;
    }

    renderFlowAddChip(popoverType) {
        let className = 'itemFilterChipRowItem addChip';
        return (
            <Chip key="add" className={className} onTouchTap={this.onAddChipClick} data-popover-type={popoverType}>
                <Avatar icon={<AddIcon />} backgroundColor="transparent" color="white" />
                Add Flow
            </Chip>
        );
    }

    popoverMenuFlowItems() {
        let menuItems = [];
        let flowIds = this.props.flowIdsAssigned.concat(this.props.flowIdsUnassigned);

        this.props.project.flows.forEach(flow => {
            let flowDisabled = flowIds.includes(flow.id);
            menuItems.push(<MenuItem key={flow.id} value={flow} primaryText={flow.name} disabled={flowDisabled}/>);
        });

        return menuItems;
    }

    popoverMenuItems() {
        switch (this.state.popoverType) {
            case PopoverType.StateIncluded:
            case PopoverType.StateExcluded:
                return this.popoverMenuStateItems();
            case PopoverType.FlowAssigned:
            case PopoverType.FlowUnassigned:
                return this.popoverMenuFlowItems();
            default:
                return null;
        }
    }

    renderPopoverMenu() {
        return (
            <Popover
                open={this.state.popoverMenuOpen}
                anchorEl={this.state.anchorEl}
                anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                targetOrigin={{horizontal: 'left', vertical: 'top'}}
                onRequestClose={this.handleRequestClose}>
                <Menu desktop={true} onChange={this.onMenuChange}>
                    {this.popoverMenuItems()}
                </Menu>
            </Popover>
        );
    }

    render() {
        return (
            <div className="itemFilter">
                <Checkbox
                    className="custom-checkbox"
                    label="Exclude all states"
                    checked={this.props.excludeAllStates}
                    onCheck={this.onExcludeAllStatesChange}
                />

                <div className="itemFilterLabel">Included States</div>
                <div className="itemFilterDescription">Choose states that must be present among item states</div>
                <div className="itemFilterChipRowWrapper">{this.renderIncludedStates()}</div>
                <div className="itemFilterLabel">Excluded States</div>
                <div className="itemFilterDescription">Choose states that must not be present among item states</div>
                <div className="itemFilterChipRowWrapper">{this.renderExcludedStates()}</div>

                <div className="itemFilterLabel">Assigned Flows</div>
                <div className="itemFilterDescription">Choose flows that must be assigned with the viewing user to items.</div>
                <div className="itemFilterChipRowWrapper flowChipRow">{this.renderAssignedFlows()}</div>
                <div className="itemFilterLabel">Unassigned Flows</div>
                <div className="itemFilterDescription">Choose flows that must not be assigned with anyone to items.</div>
                <div className="itemFilterChipRowWrapper flowChipRow">{this.renderUnassignedFlows()}</div>

                {this.renderPopoverMenu()}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/stateChipSelect/StateChipSelect.js